import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Products from "./pages/Products";
import DesignStudio from "./pages/DesignStudio";
import CustomOrder from "./pages/CustomOrder";
import Bulk from "./pages/Bulk";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AuthCallback from "./pages/AuthCallback";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import QuoteReceived from "./pages/QuoteReceived";
import AdminDiscountCodes from "./pages/AdminDiscountCodes";
import AdminInbox from "./pages/AdminInbox";
import AdminOrders from "./pages/AdminOrders";
import StickerBuilder from "./pages/StickerBuilder";
import Reviews from "./pages/Reviews";
import AdminReviews from "./pages/AdminReviews";

function AppRoutes() {
  const location = useLocation();
  // Synchronous session_id detection for Emergent OAuth callback
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/products" element={<Products />} />
        <Route path="/design-studio" element={<DesignStudio />} />
        <Route path="/custom-order" element={<CustomOrder />} />
        <Route path="/bulk" element={<Bulk />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/admin/reviews" element={<AdminReviews />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/quote-received/:order_id" element={<QuoteReceived />} />
        <Route path="/admin/discount-codes" element={<AdminDiscountCodes />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/admin/inbox" element={<AdminInbox />} />
        <Route path="/sticker-mix" element={<StickerBuilder />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
